import service from '@/utils/request'; // @Tags BairunSvcOrder
// @Summary 分页获取BairunSvcOrder列表
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body request.PageInfo true "分页获取BairunSvcOrder列表"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /bairunSvcRechargeOrder/getBairunSvcRechargeOrderList [get]

export var getBairunSvcRechargeOrderList = function getBairunSvcRechargeOrderList(params) {
  return service({
    url: '/svcManage/svcRechargeOrder/getList',
    method: 'get',
    donNotShowLoading: params.donNotShowLoading ? params.donNotShowLoading : true,
    params: params
  });
}; // exportBairunSvcBalanceOptLogList 导出储值卡充值消费明细
// @Tags Svc
// @Summary 导出储值卡充值消费明细
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body request.IdsReq true "导出储值卡充值消费明细"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /svcManage/svcBalance/consume/record [post]

export var exportBairunSvcBalanceOptLogList = function exportBairunSvcBalanceOptLogList(data) {
  return service({
    url: '/svcManage/svcBalance/consume/record',
    method: 'post',
    data: data
  });
};